import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { ComPhoto, BuyerPopup, Alert, NoResult } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class ApprovalList extends Component {
    static displayName = ApprovalList.name;

    constructor(props) {
        super(props);
        this.state = {
            WholeList: [],
            OrderList: [],
            Search_Text: "",
            Search_Type: "reg_dt",
            Bill_Yn: "N",
            Refund_Yn: "N",
            Title: "",
            Content: ""
        };
        this.ref_BuyerPopup = React.createRef();
        this.CsName = Big3Common.ContentState;
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleBuyer_Click = this.handleBuyer_Click.bind(this);
        this.handleStore_Click = this.handleStore_Click.bind(this);
        this.handleOrderList = this.handleOrderList.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    componentDidMount() {
        //상세화면 이동후 돌아왔을때 값 설정
        const proSearchText= Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchText, "");        
        this.setState({Search_Text:proSearchText});
        this.CallMyWholeListData(proSearchText);
        this.GetAlreadyOrder();
        if (this.Uid_Type === 'TS') {
            /*this.GetRefund();*/
            this.GetbillingKey();
        }
    }
    //*********내거래처 조회[s]
    async CallMyWholeListData(SearchText) {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/GetMyWholeList',
                {
                    "search_text": SearchText,
                    "search_type": this.state.Search_Type,
                    "appr_status": "WA"
                }
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ WholeList: JSON.parse(Data.dataTable) });
            }
        }
        catch (e) {
            console.log("CallMyWholeListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    async GetAlreadyOrder() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/MyPage/OrderMgr/GetAlreadyOrder", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const OrderList = JSON.parse(Data.dataTable);
                this.setState({
                    OrderList: OrderList.map(item => item.whole_code.toString())
                });
            }
        }
        catch (e) {
            console.log("GetAlreadyOrder :", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    async handleSearch_Change(event) {
         if(event.keyCode === 13)
         {
            let textVal = event.target.value;
            this.setState({Search_Text:textVal});
            await this.CallMyWholeListData(textVal);
         }
         event.preventDefault();
    }//*********내거래처 조회[e]
    handleBuyer_Click(event, whole_code) {        
        if (this.Uid_Type === 'SS') {
            this.ref_BuyerPopup.current.initWholeCode(whole_code)
            Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
            event.preventDefault();
        }
        else {
            if (this.state.Bill_Yn === 'N') {
                this.setState({ Title: "카드 등록 후 주문이 가능합니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
/*            else if (this.state.Refund_Yn === 'Y') {
                this.setState({ Title: "환불 진행중에는 주문이 불가능합니다." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }*/
            else if (this.state.Bill_Yn === 'Y' && this.state.Refund_Yn === 'N') {
                this.ref_BuyerPopup.current.initWholeCode(whole_code)
                Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
                event.preventDefault();
            }
        }
    }
     //매장상세 이동
    handleStore_Click(event,uid){
         this.props.RenderComponent("StoreDtl", {
                [this.CsName.Uid]: uid,
                [this.CsName.BackUrl]: "ApprovalList",
                [this.CsName.SearchText]:this.state.Search_Text
            });
        event.preventDefault();
    }
    handleAlert(event) {
        this.setState({
            Title: "택배주문안내",
            Content: "택배주문은 장바구니에서 가능합니다."
        });
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        event.preventDefault();
    }
    handleOrderList(whole_code) {
        if (whole_code !== undefined) {
            this.setState(prevState => ({
                OrderList: [...prevState.OrderList, whole_code.toString()]
            }));
        }
    }
    WholeLink(list) {
        if (Big3Common.Util.isEmptyOrNull(list.uid)) {
            Big3Common.ModalAlert(bootstrap, 'AlertBox');
            return false;
        }
        else {
            return (
                <div className="alert_img" onClick={(e)=>{this.handleStore_Click(e,list.uid)}}>
                    <ComPhoto className="alert_img_in" Photo={list.photo} />
                </div>
            )
        }
    }
    WholeListrender(Datalist) {
        const OrderList = this.state.OrderList;
        return (
            <>
                {
                    Datalist.map((list, idx) =>
                        <div className="alert_content_v2 alert_content" key={idx}>
                            {this.WholeLink(list)}
                            <div className="alert_txt">
                                <div className="shop_name">{list.whole_name}</div>
                                <div className="shop_address">{`${list.bld_name} ${list.flr_name} ${list.whole_no_name}호`}</div>
                                {
                                    OrderList.some(code => code === String(list.whole_code)) ? (
                                        <div className="order_btn or_btn4 btn_v2">요청완료</div>
                                    ) : (
                                        this.Uid_Type === 'SS' ? (
                                            <div className="order_btn or_btn4"
                                                onClick={(e) => { this.handleBuyer_Click(e, list.whole_code) }}
                                            >사입요청</div>
                                        ) : (
                                            <div className="order_btn or_btn4"
                                                onClick={(e) => { this.handleBuyer_Click(e, list.whole_code) }}
                                            >픽업요청</div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    )}
            </>
        );
    }
    render() {
        let WholeListrender = this.WholeListrender(this.state.WholeList);
        return (
            <div>
                <div className="tap_box">
                    <div className="t_tap"><div className="alert_tap" onClick={(e) => { this.props.RenderComponent('AccountList'); e.preventDefault(); }}>내 거래처</div></div>
                    <div className="t_tap"><div className="alert_tap tap_on">승인대기</div></div>
                    <div className="t_tap"><div className="alert_tap" onClick={(e) => { this.props.RenderComponent('WholeRequest'); e.preventDefault(); }}>거래처 등록</div></div>
                </div>
                <div className="container_box a_margin u_padding">
                    <div className="search_box_v2">
                        <div className="search_input_box search_input_box2">
                            <input type="text" placeholder="소매명을 입력해주세요."
                                className="form-control"
                                defaultValue={this.state.Search_Text}
                                onKeyUp={this.handleSearch_Change}
                            />
                            <div className="search_btn"></div>
                        </div>
                    </div>
                    {WholeListrender }
                </div>
                <BuyerPopup
                    id="BuyerPopup"
                    ref={this.ref_BuyerPopup}
                    CallBack={this.handleOrderList}
                />
                <Alert
                    id="AlertBox"
                    title="거래처보기 안내"
                    content="플랫폼에 가입된 도매가 아닙니다"
                />
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                <NoResult
                    Visible={this.state.WholeList.length === 0 ? true : false}
                    Top={"50%"}
                />
            </div>
        );
    }
}
